/**
 * String utility functions
 */

/**
 * Decode HTML entities
 * Converts HTML entities like &#x2F; → / and &amp; → &
 * @param {string} text - Text with HTML entities
 * @returns {string} - Decoded text
 */
export function decodeHtmlEntities(text) {
  if (!text) return ''
  const textarea = document.createElement('textarea')
  textarea.innerHTML = text
  return textarea.value
}

/**
 * Decode HTML entities for multiple fields in an object
 * @param {Object} obj - Object with string fields
 * @param {Array<string>} fields - Array of field names to decode
 * @returns {Object} - Object with decoded fields
 */
export function decodeObjectFields(obj, fields) {
  if (!obj) return obj

  const decoded = { ...obj }
  fields.forEach(field => {
    if (decoded[field]) {
      decoded[field] = decodeHtmlEntities(decoded[field])
    }
  })

  return decoded
}

/**
 * Decode HTML entities for array of objects
 * @param {Array<Object>} array - Array of objects
 * @param {Array<string>} fields - Array of field names to decode
 * @returns {Array<Object>} - Array with decoded fields
 */
export function decodeArrayFields(array, fields) {
  if (!Array.isArray(array)) return array

  return array.map(item => decodeObjectFields(item, fields))
}
